var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#808285;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,0.9H1c-0.5,0-1,0.4-1,1v3.4C0,5.7,0.2,6,0.6,6.2v7.9c0,0.5,0.4,1,1,1h12.9c0.5,0,1-0.4,1-1V6.2 C15.8,6,16,5.7,16,5.3V1.9C16,1.4,15.6,0.9,15,0.9z M1,1.9h14l0,0l0,3.4l-14,0L1,1.9z M1.5,14.1V6.3h13l0,7.8L1.5,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,8H5.8C5.5,8,5.3,8.2,5.3,8.5c0,0.3,0.2,0.5,0.5,0.5h4.5c0.3,0,0.5-0.2,0.5-0.5C10.7,8.2,10.5,8,10.2,8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/ArchiveIcon.520eadb590c4e283b58cc2cb5de7018b.svg";
export { ForwardRef as ReactComponent };